/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Unmatched_HintInputs */

const vi_warehouse_unmatched_hint = /** @type {(inputs: Warehouse_Unmatched_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các mã quét không tìm thấy sản phẩm — kiểm tra lại sau.`)
};

/**

* @param {Warehouse_Unmatched_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_unmatched_hint = /** @type {((inputs?: Warehouse_Unmatched_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Unmatched_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_unmatched_hint(inputs)
});